import { TENANT_PALETTE } from './tenantPalette'

export const BRANDING = {
  productName: 'econworks',
  /** Stakeholder-facing product title (TopBar, tab title, footer). */
  productTitle: 'Aleph for MMMv3',
  defaultBrandColor: '#E60000',
  /** The tenant chart palette (config/tenantPalette.ts — validated, brand slot 1).
   *  Users may override via Account→Theming (spec D1: override = user's responsibility). */
  defaultChipPalette: TENANT_PALETTE,
  copyrightFrom: 2026,
} as const
